module.exports = __webpack_public_path__ + "static/media/telegram.4ec9f0d0.svg";